import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';

const SITE_ORIGIN = 'https://www.ridenrepair.com';

const LogoSchema = ({ location }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Ride N Repair',
    'url': 'https://www.ridenrepair.com',
    'logo': 'https://www.ridenrepair.com/logo192.png',
  };

  // Global defaults — individual pages may override og:image / twitter:image
  // via their own <Helmet> (react-helmet uses last-write-wins per meta key).
  const defaultOgImage = 'https://www.ridenrepair.com/logo512.png';

  // Self-referential hreflang — targets en-IN (India-only site) and
  // x-default. Uses router location (works on both SSR via StaticRouter
  // and client via BrowserRouter). Strips trailing slash for consistency
  // with canonical URLs emitted elsewhere.
  const pathname = (location && location.pathname) || '/';
  const hreflangPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  const hreflangHref = `${SITE_ORIGIN}${hreflangPath}`;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
      <meta property="og:image" content={defaultOgImage} />
      <meta property="og:image:alt" content="Ride N Repair — Doorstep Bike & Car Service" />
      <meta property="og:site_name" content="Ride N Repair" />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@ridenrepair" />
      <meta name="twitter:image" content={defaultOgImage} />
      <link rel="alternate" hrefLang="en-IN" href={hreflangHref} />
      <link rel="alternate" hrefLang="x-default" href={hreflangHref} />
    </Helmet>
  );
};

export default withRouter(LogoSchema);